'use client'

import React, { useEffect } from 'react'

declare global {
    interface Window {
        ayManagerEnv: any
        assertive: any
    }
}

interface Props {
    width: number
    height: number
    adId: string
}

export const AYAdSlot: React.FC<Props> = (props) => {
    const { width, height, adId } = props

    useEffect(() => {
        try {
            window.ayManagerEnv = window.ayManagerEnv || { cmd: [] }
            window.ayManagerEnv.cmd.push(function () {
                window.ayManagerEnv.display(adId)
            })
        } catch (_e) {
            /* noop */
        }

        return () => {}
    }, [adId])

    return (
        <div className='ay-ad-slot m-auto bg-gray-100' style={{ width: width + 'px', minHeight: height + 'px' }}>
            <div id={adId} data-ay-manager-id={adId} />
        </div>
    )
}
